module.exports = __webpack_public_path__ + "media/4.963e8aea.mp3";